const buttons = document.querySelectorAll(".faq-btn");

buttons.forEach(button => {
  button.addEventListener("click", () => {
    const currentAnswer = button.nextElementSibling;
    const icon = button.querySelector(".d-arrow");

    // Close all other answers
    document.querySelectorAll(".faq-answer").forEach(answer => {
      if (answer !== currentAnswer) {
        answer.style.height = "0px";
        answer.classList.remove("open");
      }
    });

    // Reset all icons
    document.querySelectorAll(".d-arrow").forEach(i => {
      if (i !== icon) i.classList.remove("rotate");
    });

    // Toggle this one
    if (currentAnswer.classList.contains("open")) {
      currentAnswer.style.height = "0px";
      currentAnswer.classList.remove("open");
      icon.classList.remove("rotate");
    } else {
      currentAnswer.style.height = currentAnswer.scrollHeight + "px";
      currentAnswer.classList.add("open");
      icon.classList.add("rotate");
    }
  });
});
